import React from 'react'
import { Table } from 'react-bootstrap'

import { Student } from '@LTIDashboard/modules/SubmissionsDashboard/Students'

export function Students({ submissions }) {
  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Attempts</th>
            <th>Score</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {submissions.map((student, index) => (
            <Student index={index + 1} key={student.user.pk} data={student} />
          ))}
        </tbody>
      </Table>
    </div>
  )
}
